import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { APPCONFIG } from '../../../config';
import { IcbService } from '../../icb.service'
import { ErrorHandler } from '../../../shared/services/error-handler.service'
import { HttpService } from '../../../shared/services/http.service'
import { LayoutService } from '../../../layout/layout.service'
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { CommonService } from '../../../shared/services/common.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialog,MdDialogRef } from '@angular/material';
import { dialogComponent } from '../../../dialog/dialog.component';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import * as $ from 'jquery';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

@Component({
    selector: 'request-add',
    template: require('./data.component.html'),
    styles: [require('./data.component.scss')],
    providers: [HttpService, ErrorHandler,SessionHandler,IcbService]
})

export class t2tDataComponent {

    t2tForm: FormGroup;
    t2tFormData:any= {};
    dialogRef;
    requestFormData:any = {};
    userData:any;
    tradeId:any;
    tradeData:any = {};
    billingData:any={};
    addressList:any = [];
    contactList:any = [];
    selectedAddress:any;
    selectedContactName:any;
    selectedContactEmail:any;
    selectedContactPhone:any;
    magList:any = [];
    faultList:any = [];
    selectedMagId:any;
    selectedFaultId:any;
    daterange: any = {};
    purchaseDate:any;
    monthNames:any;
    modelNumber:any;
    isAdmin:boolean=false;
    istradePartnerId:boolean = false;
    modelList:any = [];
    isIcb:boolean = false;

	constructor(private router: Router,private route: ActivatedRoute,public Http: Http,private http:HttpService,private formBuilder: FormBuilder, private commonService : CommonService,
    private sessionHandler:SessionHandler,private dialog: MdDialog,private daterangepickerOptions: DaterangepickerConfig) {
        if(this.http.checkSession()){
            if(JSON.parse(this.sessionHandler.getItem('t2tCount')) == 1) {
                this.commonService.setData(null);
                this.sessionHandler.saveItem("t2cCount", '1');
                this.sessionHandler.saveItem("t2tCount", '1');
            }
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.magList = JSON.parse(this.sessionHandler.getItem('magList'));
            this.faultList = JSON.parse(this.sessionHandler.getItem('FaultList'));
            let icbCheck = JSON.parse(this.sessionHandler.getItem('isIcb'));
            if(icbCheck) {
                this.isIcb = true;
            } else {
                this.isIcb = false;
            }
            let data = this.commonService.getData();
            if(this.userData) {
                this.tradeId = this.userData.tradePartnerId;
                if(this.userData.role && this.userData.role.length > 0){
                    if(this.userData.role.includes('ADMIN')) {
                        this.isAdmin = true;
                    }
                    // for(let u in this.userData.role){
                    //     if(this.userData.role[u] == 'ADMIN') {
                    //         this.isAdmin = true;
                    //     }
                    // }
                }
            }

            this.monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
            ];
            console.log(this.t2tFormData);
            var today = new Date();
            this.daterange.date = today.getDate();
            this.daterange.month = today.getMonth();
            this.daterange.startYear = today.getFullYear();
            if(data && data['icbRequest']) {
                this.t2tFormData = data['icbRequest'];
                if(this.isAdmin && this.t2tFormData.tradePartnerId && this.t2tFormData.tradePartnerId != null){
                    this.tradeId = this.t2tFormData.tradePartnerId;
                    this.getTradeData();
                }
                console.log(this.t2tFormData);
            }
            // this.purchaseDate = this.daterange.date+'-'+ this.monthNames[this.daterange.month]+'-'+ this.daterange.startYear;
            this.daterangepickerOptions.settings = {
                locale: { format: 'D-MMMM-YYYY' },
                alwaysShowCalendars: false,
                singleDatePicker: true,
                maxDate: new Date(),
                opens : 'left',
                autoUpdateInput:false,
            };
            if(!this.isAdmin) {
                this.getTradeData();
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() {
        this.buildForm();
    }

    public selectedDate(value: any) {
        this.purchaseDate = value.start.format('D-MMMM-YYYY');
    }
    
    public scrollTo () {
        $('html, body').animate({
            scrollTop: $("#createdBy").offset().top
        }, 1000);
    }

    public tradePartnerIdEmptyheck(){
        this.reset();
        if(this.tradeId != null && this.tradeId != ''){
            this.istradePartnerId = true;
        }
    }

    public buildForm() {
        this.t2tForm = this.formBuilder.group({
            pickupSame: this.formBuilder.control(this.t2tFormData.pickupSame ? this.t2tFormData.pickupSame : "true",[]),
            pickupAddressId: this.formBuilder.control(this.t2tFormData.pickupAddress ? this.t2tFormData.pickupAddress : null,[Validators.required]),
            contactNameId: this.formBuilder.control(this.t2tFormData.contactName ? this.t2tFormData.contactName : null,[Validators.required]),
            contactEmailId: this.formBuilder.control(this.t2tFormData.contactEmail ? this.t2tFormData.contactEmail : null,[Validators.required]),
            contactPhoneId: this.formBuilder.control(this.t2tFormData.contactPhone ? this.t2tFormData.contactPhone : null,[Validators.required]),
            magKey: this.formBuilder.control(this.t2tFormData.mag ? this.t2tFormData.mag : null,[Validators.required]),
            modelNumber: this.formBuilder.control(this.t2tFormData.modelNumber ? this.t2tFormData.modelNumber : null,[Validators.required]),
            serialNumber: this.formBuilder.control(this.t2tFormData.serialNumber ? this.t2tFormData.serialNumber : null,[Validators.required]),
            refCode: this.formBuilder.control(this.t2tFormData.refCode ? this.t2tFormData.refCode : null,[]),
            faultId: this.formBuilder.control(this.t2tFormData.faultDescription ? this.t2tFormData.faultDescription : null,[Validators.required]),
            additionalInfo: this.formBuilder.control(this.t2tFormData.additionalInfo ? this.t2tFormData.additionalInfo : null,[])
        });
        this.t2tForm.get('pickupSame').valueChanges.subscribe(data=> {
            this.checkSameAddress(data);
        });
    }

    searchModelNumber = (data: any): Observable<any[]> => {
        let url: string = 
        APPCONFIG.appUrl+'/serviceOrder/v1/getModelNumber?key=AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y&modelNumber='+data;
        if (data) {
          return this.Http.get(url)
            .map(res => {
              let json = res.json();
              if(json.items) {
                this.modelList = json.items;
                return json.items;
              } else {
                this.modelNumber = '';
                return [];
              }
            })
        } else {
          return Observable.of([]);
        }
    }

    checkModelNumber() {
        if(this.modelList && this.modelList.length >0) {
            let check = false;
            for(let m in this.modelList) {
                if(this.modelList[m] == this.modelNumber) {
                    check = true;
                }                
            }
            if(check == false) {
                this.modelNumber = '';
            }
        }
    }

    public reset() {
        this.requestFormData = {};
        this.t2tFormData = {};
        if(this.isAdmin) {
            this.tradeData = {};
            this.billingData = {};
        }
        this.purchaseDate = this.daterange.startYear+'-'+ this.monthNames[this.daterange.month]+'-'+ this.daterange.date;
        let rawData = this.t2tForm.getRawValue();
        if(rawData.pickupSame != "true"){
            this.t2tForm.controls['pickupSame'].setValue('true');
        }
        // this.t2tForm.controls['contactNameId'].setValue(null);
        // this.t2tForm.controls['contactEmailId'].setValue(null);
        // this.t2tForm.controls['contactPhoneId'].setValue(null);
        this.t2tForm.controls['magKey'].setValue(null);
        this.t2tForm.controls['magKey'].setValue(null);
        this.t2tForm.controls['modelNumber'].setValue(null);
        this.t2tForm.controls['serialNumber'].setValue(null);
        this.t2tForm.controls['refCode'].setValue(null);
        this.t2tForm.controls['faultId'].setValue(null);
        this.t2tForm.controls['additionalInfo'].setValue(null);
        this.selectedAddress = null;
        this.selectedContactName = null;
        this.selectedContactEmail = null;
        this.selectedContactPhone =null;
        this.modelNumber = '';
        this.purchaseDate = null;
        this.setDefaultData();
        // this.setDefaultAddress();
    }

    public getTradeData(){
        this.http.getRequest('tradePartnerDetails/v1/get?tradePartnerId='+ this.tradeId)
        .subscribe(
            res => {
                this.saveTradeData(res);
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
        });
    }

    public saveTradeData(res) {
        if(res.status == "Success" && res.tradePartner) {
            this.tradeData = res.tradePartner;
            this.requestFormData['tradeData'] = this.tradeData;
            this.commonService.setData(this.requestFormData);
            this.getAddressList();
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Trade data not found.To Create new request Please save default trade details first.';
            this.dialogRef.afterClosed().subscribe(result => {
                this.router.navigateByUrl('/app/trade/details');
                this.dialogRef = null;
            });
            this.http.onEnd();
        }
    }

    public getAddressList() {
        let data = {};
        data['tradePartnerId'] = this.tradeId;
        data['salesOrgId'] = APPCONFIG.salesOrgId;
        data['isICBUser']=this.isIcb;
        this.http.postRequest(data,'tradePartnerDetails/v1/invoiceBillingAddress')
            .subscribe(
            res => {
                this.saveAddressList(res);
            },
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = err;
                }
                this.http.onEnd();
            });
    }

    public getContactList() {
        this.http.getRequest('userOperationsApi/v1/getContacts?tradePartnerId='+ this.tradeId)
        .subscribe(
            res => {this.saveContactList(res)},
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = err;
                }
                this.http.onEnd();
        });
    }

    public saveAddressList(res) {
        this.getContactList();
        if(res.billingAddress) {
            this.billingData = res.billingAddress;
        }
        if(res.shippingAddressList.length >0) {
            this.addressList  = res.shippingAddressList;
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'No address found.';
            // alert('To create new request please save address details first.');
            this.http.onEnd();
        }
    }

    public saveContactList(res) {
        if(res.items.length >0) {
        this.contactList = res.items;
        this.setDefaultData();
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'To create new request please save contact details first.';
            this.http.onEnd();
            this.router.navigateByUrl('/app/trade/details');
        }
    }

    public setDefaultAddress() {
        if(this.addressList && this.billingData){
            // let form = this.requestCreateForm.getRawValue();
            let length = this.addressList.length;
            let count = 0;
            for(let i in this.addressList) {
                if(this.addressList[i].address == this.billingData.invoiceAddress) {
                    this.selectedAddress = this.addressList[i].id;
                    let rawData = this.t2tForm.getRawValue();
                    if(rawData.pickupSame != "true"){
                        this.t2tForm.controls['pickupSame'].setValue("true");                        
                    }
                    this.t2tForm.get('pickupAddressId').disable();
                    return true;
                } else {
                    count++;
                }
            }
            if(count == length) {
                this.t2tForm.controls['pickupSame'].setValue("false");
            }
        }
    }

    public checkSameAddress(check){
        if(check == 'true') {
            let res = this.setDefaultAddress();
            if(res){
                this.t2tForm.get('pickupAddressId').disable();
            }
        } else {
            this.t2tForm.get('pickupAddressId').enable();
            if(this.t2tFormData.pickupAddressId) {
                this.selectedAddress = this.t2tFormData.pickupAddressId;
            } else if(this.tradeData.addressId) {
                let check = false;
                for(let a in this.addressList){
                    if(this.addressList[a].id == this.tradeData.addressId){
                        this.selectedAddress = this.tradeData.addressId;       
                        check = true;
                    }
                }
                if(!check && this.addressList && this.addressList.length >0) {
                    let length = this.addressList.length;
                    this.selectedAddress = this.addressList[length-1].id;
                }
            } else if(this.addressList && this.addressList.length >0) {
                let length = this.addressList.length;
                this.selectedAddress = this.addressList[length-1].id;
            }
        }
    }

    public addSerialValidation() {
        this.requestFormData['icbRequest'] = this.t2tForm.getRawValue();
        if(this.requestFormData['icbRequest'].serialNumber) {
            this.t2tForm.controls['serialNumber'].setValue(this.requestFormData['icbRequest'].serialNumber.toUpperCase());
            if(!this.SerialValidation(this.requestFormData['icbRequest'].serialNumber)) {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Invalid Serial Number. Please enter valid serial number of length 9 or 10.';
                this.t2tForm.controls['serialNumber'].setValue(null);
            }
        }
    }

    
public SerialValidation(value: string) {
    if (!value) return false;

    if (value.length === 9) {
        return /^[Ww][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(value);
    } else if (value.length === 10) {
        return /^[WwYyDd][A-Za-z][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(value);
    } else {
        return false;
    }
}


    public setDefaultData() {
        if(Object.keys(this.t2tFormData).length >0) {
            if(this.t2tFormData.contactNameId) {
                this.selectedContactName = this.t2tFormData.contactNameId;
            }
            if(this.t2tFormData.contactEmailId) {
                this.selectedContactEmail = this.t2tFormData.contactEmailId;
            }
            if(this.t2tFormData.contactPhoneId) {
                this.selectedContactPhone = this.t2tFormData.contactPhoneId;
            }
            if(this.t2tFormData.pickupAddressId) {
                this.selectedAddress = this.t2tFormData.pickupAddressId;
            }
            if(this.magList) {
                for(let m in this.magList) {
                    if(this.magList[m].magKey == this.t2tFormData.magKey) {
                        this.selectedMagId = this.magList[m].magKey;
                    }
                }
            }
            if(this.faultList) {
                for(let f in this.faultList) {
                    if(this.faultList[f].faultId == this.t2tFormData.faultId) {
                        this.selectedFaultId = this.faultList[f].faultId;
                    }
                }
            }
            this.modelNumber = this.t2tFormData.modelNumber;
        } else if(this.tradeData){
            if(this.contactList && this.contactList.length >0) {
                for(let i in this.contactList) {
                    if(this.contactList[i].contactName == this.tradeData.contactName) {
                        this.selectedContactName = this.contactList[i].id;
                    }
                    if(this.contactList[i].contactEmail == this.tradeData.contactEmail) {
                        this.selectedContactEmail = this.contactList[i].id;
                    }
                    if(this.contactList[i].contactPhone == this.tradeData.contactPhone) {
                        this.selectedContactPhone = this.contactList[i].id;
                    }
                }
            }
            if(this.addressList && this.addressList.length >0) {
                for(let i in this.addressList) {
                    if(this.addressList[i].address == this.billingData.invoiceAddress) {
                        this.selectedAddress = this.addressList[i].id;
                    }
                }
            }
        }
        if(Object.keys(this.t2tFormData).length >0) {
            if(this.t2tFormData.pickupSame == true || this.t2tFormData.pickupSame == 'true'){
                this.t2tForm.controls['pickupSame'].setValue("true");
                this.checkSameAddress('true');
            } else if(this.t2tFormData.pickupSame == false || this.t2tFormData.pickupSame == 'false') {
                this.t2tForm.controls['pickupSame'].setValue("false");
                this.checkSameAddress('false');   
            }
        } else {
            this.setDefaultAddress();
        }
        this.http.onEnd();
    }

    public setFormDetails(){
        if(this.purchaseDate){
            this.requestFormData['icbRequest'].purchaseDate = this.purchaseDate;
        }
        this.requestFormData['icbRequest'].tradeName = this.tradeData.name1+this.tradeData.name2;
        this.requestFormData['icbRequest'].tradePartnerId = this.tradeId;
        this.requestFormData['icbRequest'].billingAddress = this.billingData.invoiceAddress;
        this.requestFormData['icbRequest'].consumerCountry = this.userData.country;
        if(this.addressList) {
            for(let i in this.addressList) {
                if(this.addressList[i].id == this.requestFormData['icbRequest'].pickupAddressId) {
                    this.requestFormData['icbRequest'].pickupAddress = this.addressList[i].address;
                    this.requestFormData['icbRequest'].tradePartnerAddress = this.addressList[i];
                }
            }
        }
        if(this.contactList) {
            for(let i in this.contactList) {
                if(this.contactList[i].id == this.requestFormData['icbRequest'].contactNameId) {
                    this.requestFormData['icbRequest'].contactName = this.contactList[i].contactName;
                }
                if(this.contactList[i].id == this.requestFormData['icbRequest'].contactEmailId) {
                    this.requestFormData['icbRequest'].contactEmail = this.contactList[i].contactEmail;
                }
                if(this.contactList[i].id == this.requestFormData['icbRequest'].contactPhoneId) {
                    this.requestFormData['icbRequest'].contactPhone = this.contactList[i].contactPhone;
                }
            }
        }
        if(this.magList) {
            for(let m in this.magList) {
                if(this.magList[m].magKey == this.requestFormData['icbRequest'].magKey) {
                    this.requestFormData['icbRequest'].mag = this.magList[m].labelEnglish;
                }
            }
        }
        if(this.faultList) {
            for(let f in this.faultList) {
                if(this.faultList[f].faultId == this.requestFormData['icbRequest'].faultId) {
                    this.requestFormData['icbRequest'].faultDescription = this.faultList[f].labelEnglish;
                }
            }
        }
        return true;
    }

    public goToNextPage() {
        this.requestFormData['icbRequest'] = this.t2tForm.getRawValue();
        this.requestFormData['icbRequest'].isT2C = false;
        if(this.setFormDetails()){
            this.http.postRequest(this.requestFormData['icbRequest'],'serviceOrder/v1/registerBpDetails')
            .subscribe(
            res => {
                this.saveBPresponse(res);
            },
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = err;
                }
                this.http.onEnd();
            });
        }
    }

    public saveBPresponse(res) {
        if(res.status == 'Success') {
            this.requestFormData['icbRequest'].applianceId = res.applianceId;
            this.requestFormData['icbRequest'].dealerId = res.bpRegId;
            console.log(this.requestFormData);
            this.sessionHandler.saveItem("t2tCount", '2');
            this.commonService.setData(this.requestFormData);
            this.router.navigateByUrl('/app/icb/trade/summary');
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
        this.http.onEnd();
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb/t2t/data/data.component.ts